import React from "react";
import { Message } from "semantic-ui-react";

export default function ConfirmOptin() {
    return (
        <Message>
            <Message.Header>Good Job !</Message.Header>
            <p>You are now Optin !</p>
        </Message>
    );
}